import { AtlasScalingVariantData, CompressedMultiAtlasScalingVariantData, MultiAtlasScalingVariantData, TextureScalingVariantData } from "../types/types";
import { RectSize } from "./RectSize";

export function GameWidth(scene: Phaser.Scene): number
{
    return this.scene.sys.game.config.width as number;
}
export function GameHeight(scene: Phaser.Scene): number
{
    return this.scene.sys.game.config.height as number;
}

/**
 * Returns seconds in string representation: HH:MM:SS
 * @param seconds 
 */
export function SecondsToTimeString(seconds: number): string
{
    var date = new Date(0);
    date.setSeconds(seconds); // specify value for SECONDS here
    var timeString = date.toISOString().substr(11, 8);
    return timeString;
}

/**
 * Return Get Query Parameter value by Key
 * @param key 
 * @returns 
 */
export function GetQueryParameter(key: string)
{
    // Address of the current window
    const address:string = window.location.search;
    
    // Returns a URLSearchParams object instance
    const parameterList = new URLSearchParams(address);
    
    // Returning the respected value associated
    // with the provided key
    return parameterList.get(key);
}

export enum ScaleMode {
    /**
     * Resize to fit rectangle, allow letterboxing (black stripes on sides)
     */
    LETTER_BOX,
    /**
     * Resize to fit rectangle, no letterboxing (allow overflow - crop sides)
     */
    CROP_OUTSIDE,
    /**
     * Stretch in bothdirection to fill rectangle, do not keep aspect ration when resizing
     */
    RESIZE,
    /**
     * Do not do any scaling whatsoever
     */
    NO_SCALE
}

/**
 * Get scale factor from trying to fit @see sourceRect into @see targetRect using @see scaleMode
 */
export function GetScaleFactor(sourceRect: RectSize, targetRect: RectSize, scaleMode: ScaleMode): RectSize
{
    var widthRatio: number;
    let heightRatio: number;
    let ar: number;

    switch(scaleMode) {
        // for letter_box, take the smaller AR (from target/source) 
        // and multiply both directions with it (preserve AR)
        case ScaleMode.LETTER_BOX:
            widthRatio = targetRect.width / sourceRect.width;
            heightRatio = targetRect.height / sourceRect.height;
            ar = widthRatio < heightRatio ? widthRatio : heightRatio;
            return new RectSize(ar);

        // for crop_outside, take the bigger AR (from target/source) and 
        // multiply both directions with it (preserve AR)
        case ScaleMode.CROP_OUTSIDE:
            widthRatio = targetRect.width / sourceRect.width;
            heightRatio = targetRect.height / sourceRect.height;
            ar = widthRatio > heightRatio ? widthRatio : heightRatio;
            return new RectSize(ar);

        case ScaleMode.RESIZE:
            widthRatio = targetRect.width / sourceRect.width;
            heightRatio = targetRect.height / sourceRect.height;
            return new RectSize(widthRatio, heightRatio);

        case ScaleMode.NO_SCALE:
            return new RectSize(1);
    }
}

export function GetTextureScalingVariantDataByScale(variants:TextureScalingVariantData[], scale:number): TextureScalingVariantData
{
    for (let i:number = 0; i<variants.length; i++) {
        if (variants[i].scale == scale) {
            return variants[i];
        }
    }
    return null;
}


export function GetAtlasScalingVariantDataByScale(variants:AtlasScalingVariantData[], scale:number): AtlasScalingVariantData
{
    for (let i:number = 0; i<variants.length; i++) {
        if (variants[i].scale == scale) {
            return variants[i];
        }
    }
    return null;
}

export function GetMultiAtlasScalingVariantDataByScale(variants:MultiAtlasScalingVariantData[], scale:number): MultiAtlasScalingVariantData
{
    for (let i:number = 0; i<variants.length; i++) {
        if (variants[i].scale == scale) {
            return variants[i];
        }
    }
    return null;
}

export function GetCompressedMultiAtlasScalingVariantDataByScale(variants:CompressedMultiAtlasScalingVariantData[], scale:number): CompressedMultiAtlasScalingVariantData
{
    for (let i:number = 0; i<variants.length; i++) {
        if (variants[i].scale == scale) {
            return variants[i];
        }
    }
    return null;
}